<template>
  <div v-if="interaction" class="md-layout interaction-item">
    <div class="md-layout-item md-size-25">
      <div v-if="interaction.direction" style="font-size:30px;">
        <i class="fas" :class="directionStyle">
          <md-tooltip md-direction="top">{{ interactionDirection }}</md-tooltip>
        </i>
      </div>

      <h6 v-if="interaction.type" class="text-primary interaction-type">
        {{ interactionType }}
      </h6>

      <div>
        <div class="md-caption">Created On</div>
        <div>{{ interaction.created_at | formatDate }}</div>
      </div>

      <div class="actions">
        <md-button
          class="md-primary md-just-icon md-simple action-button"
          @click.stop="editInteraction(interaction)"
        >
          <md-icon><md-icon>edit</md-icon></md-icon>
          <md-tooltip md-direction="top">Edit Interaction</md-tooltip>
        </md-button>
        <md-button
          class="md-danger md-just-icon md-simple action-button"
          @click.stop="deleteInteraction(interaction)"
        >
          <md-icon>delete</md-icon>
          <md-tooltip md-direction="top">Delete Interaction</md-tooltip>
        </md-button>
      </div>
    </div>
    <div
      class="md-layout-item md-size-75 text-editor-content"
      v-html="interaction.content"
    ></div>
  </div>
</template>

<script>
import confirm from "@/helpers/deleteConfirm";

export default {
  data() {
    return {};
  },

  props: {
    interaction: {
      type: Object,
      default: () => ({ direction: {} })
    }
  },

  computed: {
    directionStyle() {
      return this.interaction?.direction?.value == "incoming"
        ? ["text-success", "fa-sign-in-alt"]
        : ["text-warning", "fa-sign-out-alt"];
    },
    interactionType() {
      return this.interaction?.type?.description ?? "Not Set";
    },
    interactionDirection() {
      return this.interaction?.direction?.description ?? "Not Set";
    }
  },

  methods: {
    deleteInteraction(interaction) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          this.$emit("deleteInteraction", interaction);
        }
      });
    },

    editInteraction(interaction) {
      this.$emit("editInteraction", interaction);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.interaction-item {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 10px 10px 20px;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
  margin-bottom: 25px;

  .interaction-type {
    margin: 0.5rem 0 0.2rem 0;
  }

  .actions {
    margin-top: 15px;

    .action-button {
      width: 24px;
      min-width: 24px;
      height: 24px;
      margin: 0px;
    }
  }
}
</style>
